import { callMdaeApi } from "../../../call-web-api";
import { throwExceptionErrors } from "../../../utils/fetch";

// Shared GET helper for the Audit Queue v1 endpoints.
//
// callMdaeApi prefixes every request with the enterprise API base URL cached in
// sessionStorage ('mdae-api-new-base-url'), which is seeded from the backend
// config key MdaeApiBaseUrl.
const BASE_URL_KEY = "mdae-api-new-base-url";

// Hard ceiling for any single audit-queue request. callMdaeApi resolves the API
// base URL and okta token before firing the actual fetch, and none of those
// steps carry a timeout — if the base-url helper 500s (its .then has no .catch)
// or the enterprise host stalls, the promise never settles and the page is
// stuck on "Loading…". Racing every call against this timeout guarantees the
// async-op always settles, so the reducer leaves the loading state.
const REQUEST_TIMEOUT_MS = 15000;

const withTimeout = <T>(promise: Promise<T>, ms: number, label: string): Promise<T> => {
  let timer: ReturnType<typeof setTimeout>;
  const timeout = new Promise<never>((_, reject) => {
    timer = setTimeout(() => {
      const e: any = new Error(`Request timed out after ${ms}ms`);
      e.status = 0;
      e.statusText = "timeout";
      e.url = label;
      e.isTimeout = true;
      reject(e);
    }, ms);
  });
  return Promise.race([promise, timeout]).finally(() => clearTimeout(timer)) as Promise<T>;
};

export const callEnterpriseApi = async (path: string) => {
  let base = "";
  try {
    base = window.sessionStorage.getItem(BASE_URL_KEY) || "";
  } catch (e) {
    /* noop */
  }

  const response = await withTimeout(
    callMdaeApi({ type: "GET", url: path }),
    REQUEST_TIMEOUT_MS,
    base + path
  );
  throwExceptionErrors(response as any);
  return response;
};
